
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { TransferModel } from './Entities.GormCrm.Transfer';
import { Model, ModelProperty } from 'models/Model';


export class TransferPlanModel extends Model<TransferPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'transferPlan.property.id', isHidden: true },
		{ name: 'transferId', type: 'guid', languageString: 'transferPlan.property.transferId' },
		{ name: 'productPlanId', type: 'guid', languageString: 'transferPlan.property.productPlanId' },
		{ name: 'productPlan', type: 'ProductPlanModel', languageString: 'transferPlan.property.productPlan', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'transfer', type: 'TransferModel', languageString: 'transferPlan.property.transfer', isHidden: true, isObject: true, new: () => { return new TransferModel }, properties: () => { return TransferModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public transferId?: string;
	public productPlanId?: string;
	public productPlan?: ProductPlanModel;
	public transfer?: TransferModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.transferId = undefined;
		this.productPlanId = undefined;
		this.productPlan = undefined;
		this.transfer = undefined;
		
	}
	getProperties(){
		return TransferPlanModel.classProperties;
	}
}

